import { useState, useCallback } from 'react';
import { useGetCompetitionByIdQuery } from '@/store/api/sidebarApi';
import { useGetEventsQuery } from '@/store/api/eventsApi';
import { useIsAuthenticated } from '@/hooks';

export const sportsData = [
  { id: 1, name: 'Cricket', imgUrl: '/images/sidebar/cricket-icon.png', apiName: 'Cricket', urlPath: 'cricket' },
  { id: 2, name: 'Soccer', imgUrl: '/images/sidebar/soccer-icon.png', apiName: 'Soccer', urlPath: 'football' },
  { id: 3, name: 'Tennis', imgUrl: '/images/sidebar/tennis-icon.png', apiName: 'Tennis', urlPath: 'tennis' },
  { id: 4, name: 'Horse Racing', imgUrl: '/images/sidebar/horse-icon.png', apiName: null, urlPath: null },
  { id: 5, name: 'Greyhound', imgUrl: '/images/sidebar/greyhound-icon.png', apiName: null, urlPath: null },
];

export const useSidebar = () => {
  const [openSport, setOpenSport] = useState<number | null>(null);
  const [openCompetition, setOpenCompetition] = useState<number | null>(null);
  const isAuthenticated = useIsAuthenticated();

  const selectedSport = sportsData.find((s) => s.id === openSport) ?? null;

  const { data: competitionsData, isFetching: competitionsLoading } = useGetCompetitionByIdQuery(
    selectedSport?.apiName ?? '',
    { skip: !selectedSport?.apiName }
  );
  const competitions = competitionsData?.competitions ?? [];

  const { data: eventsData, isFetching: eventsLoading } = useGetEventsQuery(
    { competitionId: openCompetition ?? undefined },
    { skip: openCompetition === null }
  );
  const events = eventsData?.fixture ?? [];

  const toggleSport = useCallback((sportId: number) => {
    setOpenSport((prev) => (prev === sportId ? null : sportId));
    setOpenCompetition(null);
  }, []);

  const toggleCompetition = useCallback((competitionId: number) => {
    setOpenCompetition((prev) => (prev === competitionId ? null : competitionId));
  }, []);

  return {
    sportsData,
    openSport,
    openCompetition,
    selectedSport,
    competitions,
    competitionsLoading,
    events,
    eventsLoading,
    isAuthenticated,
    toggleSport,
    toggleCompetition,
  };
};
